import {MessageConvertResponse} from "../../infra/api/service/message_api_convert";
import moment from "moment";

export class Message {

    public static from(from: MessageConvertResponse): Message {

        return new Message(
            from.id,
            from.roomID,
            from.fromID,
            from.toID,
            from.fromCompany,
            from.text,
            from.gsImageURL,
            from.signedImageURL,
            from.gsFileURL,
            from.signedFileURL,
            from.createdAt,
        );
    }

    constructor(public readonly id: string,
                public readonly roomID: string,
                public readonly fromID: string,
                public readonly toID: string,
                public readonly fromCompany: boolean,
                public readonly text: string,
                public readonly gsImageURL: string,
                public readonly signedImageURL: string,
                public readonly gsFileURL: string,
                public readonly signedFileURL: string,
                public readonly createdAt: Date) {
    }

    public getCreatedAtString(): string {
        return moment(this.createdAt).format("YYYY/MM/DD");
    }

    public getCreatedAtStringShort(): string {
        return moment(this.createdAt).format("M/D hh:mm");
    }

}



// WEBPACK FOOTER //
// ./src/domain/model/message.ts